export default __webpack_public_path__ + "static/media/Project3_TechnicalSummary.e8752ef0.pdf";